import React from 'react'

const About = () => {
    return (
        <div className='about'>
            <div className="about__container container">
                <h2 className="about__title">About us</h2>
                <div className="about__desc"><p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p></div>
            </div>
            <div className="about__author-img">
                <div className="author-img1 img__item" ></div>
                <div className="author-img2 img__item" > </div>
                <div className="author-img3 img__item" ></div>
                <div className="author-img4 img__item" ></div>
                <div className="author-img5 img__item" ></div>
                <div className="author-img6 img__item" ></div>
                <div className="author-img7 img__item" ></div>
            </div>
        </div>
    )
}

export default About